import { exec, getApiToken } from '../utils';
import type {
  GetRepairFiltersArgs,
  GetRepairFiltersExecVariables,
  GetRepairFiltersExecResponse,
  RepairFilterType,
} from '@src/types';

/**
 * Fetches available filter options for repairs (valid problems and states)
 * Automatically exchanges JWT for badge token if needed
 * @param args - Partner code to fetch filters for
 * @returns Promise resolving to repair filter options
 */
export const getRepairFilters = async (
  args: GetRepairFiltersArgs
): Promise<RepairFilterType> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const variables: GetRepairFiltersExecVariables = {
    ...args,
    token: apiToken,
  };

  const searchQuery = `
    query getRepairFilters(
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          repairFilters {
            validProblems {
              code
              name
            }
            validStates {
              code
              name
            }
          }
        }
      }
    }
  `;

  const data = await exec<
    GetRepairFiltersExecVariables,
    GetRepairFiltersExecResponse
  >(searchQuery, {
    variables,
  });

  return data.restUser.partner.repairFilters;
};
